import React from "react";
import LeftTime from "./LeftTime";
import LeftImages from "./LeftImages";
import LeftAttachment from "./LeftAttachment";
import LeftMessage from "./LeftMessage";
import LeftAvatar from "./LeftAvatar";
import { formatTime } from "../../../../../helpers";

const LeftSec = ({ group }) => {
  return (
    <>
      <div className="flex items-end float-left mb-4 -intro-x chat-text-box">
        <LeftAvatar
          src={group?.user?.image?.url}
          alt={`${group?.user?.firstName || ""} ${group?.user?.lastName || ""}`}
        />
        <div className="w-full space-y-2">
          {group?.message?.map((msg, i) => (
            <div key={i?.toString()}>
              {!msg?.content && msg?.attachmentInfo?.length > 0 && (
                <div className="bg-white h-10 rounded-md shadow">
                  <LeftImages
                    images={msg?.attachmentInfo
                      ?.filter((attach) => attach?.mediaType === "image")
                      ?.map((attach) => ({
                        src: attach?.url,
                        alt: attach?.name,
                      }))}
                    content={msg?.content || " "}
                  />
                  <div className="clear-both" />
                </div>
              )}
              {msg?.content && msg?.attachmentInfo?.length === 0 && (
                <LeftMessage text={<div>{msg?.content}</div>} />
              )}
              <div className="clear-both" />
              {msg?.attachmentInfo?.length > 0 && (
                <>
                  <LeftImages
                    images={msg?.attachmentInfo
                      ?.filter((attach) => attach?.mediaType === "image")
                      ?.map((attach) => ({
                        src: attach?.url,
                        alt: attach?.name,
                      }))}
                    content={msg?.content}
                  />
                  <div className="clear-both" />
                </>
              )}
              {/* <LeftAttachment
              ext={"JPG"}
              fileName={"preview-8.jpg"}
              fileSize={"1.2 MB"}
              fileType={"Image"}
            /> */}
              {/* <div className="clear-both" /> */}
              {group?.message?.length === i + 1 && (
                <>
                  <div className="clear-both mb-2" />
                  <LeftTime
                    time={formatTime(group?.message?.at(-1)?.createdAt)}
                  />
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="clear-both" />
    </>
  );
};

export default LeftSec;
